<template>
  <div :class="$style.sectionSecondary">
    <div class="section container">
      <div class="row sectionSecondary__list">
        <div class="col-xl-5 col-12 sectionSecondary__item">
          <div class="sectionSecondary__item--left">
            <DingBeautySectionTitle title="為您的服務帶來專業優勢" sub-title="Become a Pro"></DingBeautySectionTitle>
            <el-collapse v-model="activeName" accordion class="sectionSecondary__collapse isStyleBase">
              <el-collapse-item v-for="(item, $index) in list" :key="$index" :name="`${$index}`">
                <template slot="title">
                  <img class="icon-shiny" src="@assets/images/home/icon_shiny.svg" alt="" />
                  <div v-html="item.title"> </div>
                </template>
                <div v-html="item.content"></div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <img class="pc-image" src="@src/assets/dingbeauty-images/home/Pro@2.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import DingBeautySectionTitle from '@components/DingBeauty/DingBeautySectionTitle.vue'

export default {
  components: {
    DingBeautySectionTitle,
  },
  data() {
    return {
      activeName: '0',
      list: [
        {
          title: '品牌專屬官網',
          content: '<p>為您打造品牌專屬預約網站，擴大線上渠道的可見性！<br>再也不需要花錢建構官方網站，愛美訂提供您連動預約服務的官網，為您的行銷加分！</p>',
        },
        {
          title: '多元預約方式',
          content: '愛美訂整合線上線下預約，讓您忙碌時不再錯失商機！<br>不論是透過網站、Google地圖或是LINE，讓您的客人輕鬆上手，隨時預約，抓住所有潛在機會！',
        },
        {
          title: '線上金流開通',
          content: '不再需要額外跑流程申請刷卡機，透過愛美訂系統直接進行刷卡付款！讓您省去繁複申請流程，直接透過愛美訂進行刷卡付款，提供使用者更便利的支付方式！',
        },
        {
          title: 'Line線上預約',
          content: '<p>幫您整合官方Line，為使用者提供無縫預約體驗！<br>讓客戶輕鬆預約、輕鬆查詢包月與儲值狀態，提升使用者體驗並促進品牌行銷！</p>',
        },
      ],
    }
  },
}
</script>

<style lang="scss" module>
$color-primary: #d8b37f;

.sectionSecondary {
  position: relative;

  :global {
    .icon-shiny {
      margin-right: 16px;
    }

    .row {
      position: relative;
    }

    .pc-image {
      display: none;
    }

    .sectionSecondary {
      &__item {
        &--left {
        }
        &--right {
          background-image: url('~@src/assets/dingbeauty-images/home/Pro@1.png');
          background-repeat: no-repeat;
          background-size: cover;
          width: 100%;
          padding-bottom: 91%;
          position: relative;
          right: 0;
          padding-left: 0;
          margin-top: 44px;
          overflow: hidden;
          @media only screen and (-webkit-min-device-pixel-ratio: 2),
            only screen and (min--moz-device-pixel-ratio: 2),
            only screen and (-o-min-device-pixel-ratio: 2/1),
            only screen and (min-device-pixel-ratio: 2),
            only screen and (min-resolution: 192dpi),
            only screen and (min-resolution: 2dppx) {
            background-image: url('~@src/assets/dingbeauty-images/home/Pro@2.png');
          }
        }
      }
      &__collapse {
        // margin-top: 105px;
      }
    }
    .el-collapse {
      &.isStyleBase {
        border-top: 0;
        border-bottom: 0;
        .el-collapse-item {
          border: 1px solid rgba(237, 240, 244, 1);
          margin-top: 12px;
          padding-left: 36px;
          padding-right: 36px;

          &.is-active {
            background: #fcfcfc;
            .el-collapse-item__header {
              background: #fcfcfc;
            }
            .el-collapse-item__wrap {
              background: #fcfcfc;
            }
          }
          @include max-md {
            padding-left: 24px;
            padding-right: 24px;
          }
          &__header {
            font-size: 18px;
            font-weight: 600;
            height: 70px;
            line-height: 1.75;
            border-bottom: 0;
            &.is-active {
              background: rgba(233, 235, 247, 0.15);
            }
            // &:before {
            //   content: '';
            //   display: inline-block;
            //   width: 20px;
            //   height: 20px;
            //   background-image: url('~@assets/images/home/icon_shiny.svg');
            //   background-size: cover;
            //   margin-right: 1rem;
            // }
          }
          &__wrap {
            border-bottom: 0;
          }
          &__arrow {
            transform: rotate(-90deg);
            color: $color-primary;
            &.is-active {
              transform: rotate(90deg);
            }
          }
        }
      }
    }
  }
}

@media (min-width: 1200px) {
  .sectionSecondary {
    :global {
      .section {
      }

      .sub-title {
        text-align: left;
      }

      .pc-image {
        display: block;
        position: absolute;
        max-height: 600px;
        left: 48%;
        top: -16px;
      }
    }
  }
}
</style>
